export enum ClaimTypeEnum {
  ValidValue  = 'E8EEBF02-3E4D-4973-9679-156527D0DEEB',
  Predetermination  = '00000093-1000-0000-0000-000000000001',
  RealClaim         = '00000093-1000-0000-0000-000000000002',
  SecondaryRealClaim         = '00000093-1000-0000-0000-000000000003',
}
